import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type LoginResponse } from '../../api/schema-dtos/AuthDomainDtos'
import { type RootState } from '../../app/store'

export interface AuthSliceState {
  authenticated: boolean
  assetHolderId: number | null
  accessToken: string | null
  bearerAccessToken: string
  userProfileName: string
  userSettlementsEnabled: boolean
  userPendingSettlementsAvailable: boolean
}

const initialState: AuthSliceState = {
  authenticated: false,
  assetHolderId: null,
  accessToken: null,
  bearerAccessToken: '',
  userProfileName: '',
  userSettlementsEnabled: false,
  userPendingSettlementsAvailable: false
}

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    authReceiveToken: (state, action: PayloadAction<LoginResponse>) => {
      state.accessToken = action.payload.accessToken
      state.assetHolderId = action.payload.assetHolderId
      state.userProfileName = action.payload.userProfileName
      state.userSettlementsEnabled = action.payload.userSettlementsEnabled
      state.userPendingSettlementsAvailable = action.payload.userPendingSettlementsAvailable
      state.authenticated = true
      state.bearerAccessToken = `Bearer ${action.payload.accessToken}`
    },
    authClearToken: (state) => {
      state.authenticated = false
      state.assetHolderId = null
      state.userProfileName = ''
      state.userSettlementsEnabled = false
      state.userPendingSettlementsAvailable = false
      state.accessToken = null
      state.bearerAccessToken = ''
    }
  }
})

export const {
  authReceiveToken,
  authClearToken
} = authSlice.actions

export const selectAuthAuthenticated = (state: RootState): boolean => state.authSlice.authenticated
export const selectAuthAssetHolderId = (state: RootState): number | null => state.authSlice.assetHolderId
export const selectAuthUserSettlementsEnabled = (state: RootState): boolean => state.authSlice.userSettlementsEnabled
export const selectAuthUserPendingSettlementsAvailable = (state: RootState): boolean => state.authSlice.userPendingSettlementsAvailable
export const selectAuthState = (state: RootState): AuthSliceState => state.authSlice

// We currently access the bearer token directly from the state; see proximaApi.ts
// export const selectAuthBearerAccessToken = (state: RootState): string => state.authSlice.bearerAccessToken
// export const selectAuthAccessToken = (state: RootState): string | null => state.authSlice.accessToken
// export const selectAuthUserProfileName = (state: RootState): string => state.authSlice.userProfileName

export default authSlice.reducer

// export const selectAuthAuthenticated = (state: RootState): boolean => state.authSlice.authenticated
